(function () {

  angular.module("app")
    .filter("moment", [
      function () {
        return function (date, method) {
          var momented = window.moment(date);
          return momented[method].apply(momented, Array.prototype.slice.call(arguments, 2));
        };
      }
    ]);

  angular.module("app")
    .filter("momentParse", [
      function () {
        return function (date, format) {
          return window.moment(date, format);
        };
      }
    ]);

  angular.module("app")
    .filter("colorFilter", function () {
      function hexToRgb(hex) {
        // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
        var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
        hex = hex.replace(shorthandRegex, function (m, r, g, b) {
          return r + r + g + g + b + b;
        });

        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? {
          r: parseInt(result[1], 16),
          g: parseInt(result[2], 16),
          b: parseInt(result[3], 16)
        } : null;
      }

      function rgbToHex(r, g, b) {
        return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
      }

      function shadeColor(color, percent) {
        var f = parseInt(color.slice(1), 16),
          t = percent < 0 ? 0 : 255,
          p = percent < 0 ? percent * -1 : percent,
          R = f >> 16,
          G = f >> 8 & 0x00FF,
          B = f & 0x0000FF;
        return "#" + (0x1000000 + (Math.round((t - R) * p) + R) * 0x10000 + (Math.round((t - G) * p) + G) * 0x100 + (Math.round((t - B) * p) + B)).toString(16).slice(1);
      }

      function blendColors(c0, c1, p) {
        var f = parseInt(c0.slice(1), 16),
          t = parseInt(c1.slice(1), 16),
          R1 = f >> 16,
          G1 = f >> 8 & 0x00FF,
          B1 = f & 0x0000FF,
          R2 = t >> 16,
          G2 = t >> 8 & 0x00FF,
          B2 = t & 0x0000FF;
        return "#" + (0x1000000 + (Math.round((R2 - R1) * p) + R1) * 0x10000 + (Math.round((G2 - G1) * p) + G1) * 0x100 + (Math.round((B2 - B1) * p) + B1)).toString(16).slice(1);
      }

      return function (input, type, value) {
        var returnVal;

        if (type === "darken") {
          returnVal = shadeColor(input, value * -1);
        }

        if (type === "lighten") {
          returnVal = shadeColor(input, value);
        }

        return returnVal;
      }
    });

  angular.module("app")
    .filter("unsafe", ["$sce", function ($sce) {
      return $sce.trustAsHtml;
    }]);

})();




// WEBPACK FOOTER //
// ./app/alk-common/filters.js